<div fxLayout="column" class="gap-2 m-b-10">
    <div class="vstack">
        <div class="HeaderSet"
             *ngIf="HeaderSet && requestService.selectedRequest.status.dev_name != 'booking_confirmed'"
             matTooltip="These are terms which were agreed at the time of Booking Confirmation, any changes in terms
                will be reflected in the Booking Summary section">
            <span class="editHead editHeadCursor" (click)="reviewQuote = !reviewQuote">
                Quotation
                <i class="flaticon-down-chevron" [ngClass]="reviewQuote? 'more':'' "></i>
            </span>
        </div>
        <div class="reviewBox" [class.viewExpand]="reviewQuote">
            <div class="quotedate shadoo">
                <ng-container *ngIf="requestService.selectedRequest.status.dev_name != 'booking_confirmed'">
                    <label>Quotation Date: {{currentDate | date:"dd MMM, yyyy"}}</label>
                    <label class="dateValid" *ngIf="!requestService.confirmBooking">Quotation Valid Till:
                        <b>{{commercials?.quote_valid_till | date:"dd MMM, yyyy"}}</b></label>
                </ng-container>
                <ng-container *ngIf="requestService.selectedRequest.status.dev_name == 'booking_confirmed'">
                    <label>Deal Confirmation Date: {{commercials?.created_at | date:"dd MMM, yyyy"}}</label>
                    <div style="display: flex; gap: 5px;">
                        <button
                                [matTooltip]="requestService.selectedRequest.status.dev_name == 'booking_confirmed'? 'Download Smart Contract':'Download Quote'"
                                matTooltipPosition="left" class="editRequest downloadQuoteBtn" mat-icon-button
                                (click)="downloadQuote(commercials)">
                            <i class="flaticon-download"></i>
                        </button>
                        <button [matTooltip]="'Send Smart Contract'" class="editRequest downloadQuoteBtn"
                                mat-icon-button
                                *ngIf="requestService.selectedRequest.status.dev_name == 'booking_confirmed'" (click)="openSendQuoteConfirmationDialog(commercials?.id,
                                requestService.selectedRequest.request_type.dev_name == 'one_way' ? 'oneway' : 'trade'
                            , 'Smart contract shared on email', 'booking')">
                            <i class="flaticon-email"></i>
                        </button>
                    </div>
                </ng-container>
            </div>

            <div fxLayout="row wrap" class="wholeReview">
                <div fxLayout="column" fxFlex="65" class="leftReview">
                    <div fxLayout="column" class="w-100 shadoo "
                         *ngIf="requestService.selectedRequest.request_type.dev_name == 'one_way'">
                        <span class="title">LOCATION DETAILS</span>
                        <div class="locationBox">
                            <div class="rowSet locBox">
                                <span>Pick-up Location :</span>
                                <ng-container *ngIf="commercials.quote_items[0]?.pol_list.length != 0">
                                    <span
                                            class="location">{{commercials.quote_items[0]?.pol_list[0].name_display}}</span>
                                    <span class="location"
                                          *ngIf="commercials.quote_items[0]?.pol_list?.length > 1">{{
                                            commercials.quote_items[0]?.pol_list[1]?.name_display
                                        }}</span>
                                    <span class="location"
                                          *ngIf="commercials.quote_items[0]?.pol_list?.length > 2">{{
                                            commercials.quote_items[0]?.pol_list[2]?.name_display
                                        }}</span>
                                    <span class="location"
                                          *ngIf="commercials.quote_items[0]?.pol_list?.length > 3">{{
                                            commercials.quote_items[0]?.pol_list[3]?.name_display
                                        }}</span>
                                    <span class="location"
                                          *ngIf="commercials.quote_items[0]?.pol_list?.length > 4">{{
                                            commercials.quote_items[0]?.pol_list[4]?.name_display
                                        }}</span>
                                    <span class="location"
                                          *ngIf="commercials.quote_items[0]?.pol_list?.length > 5">{{
                                            commercials.quote_items[0]?.pol_list[5]?.name_display
                                        }}</span>
                                    <span class="additionalName"
                                          *ngIf="commercials.quote_items[0]?.pol_list?.length > 6"
                                          [matTooltipShowDelay]="400"
                                          [matTooltip]="commercials.quote_items[0]?.pol_list | tooltipList"
                                          matTooltipClass="tooltip-list">
                                        {{
                                            commercials.quote_items[0]?.pol_list?.length > 6 ? "+" +
                                                (commercials.quote_items[0]?.pol_list?.length - 6) +
                                                " more locations" :
                                                commercials.quote_items[0]?.pol_list?.length == 6 ? "+" +
                                                    (commercials.quote_items[0]?.pol_list?.length - 6) +
                                                    " more locations" : ''
                                        }}
                                    </span>
                                </ng-container>
                            </div>
                            <div class="rowSet locBox">
                                <span>Drop-off Location :</span>
                                <ng-container *ngIf="commercials.quote_items[0]?.pod_list.length != 0">
                                    <span
                                            class="location">{{commercials.quote_items[0]?.pod_list[0].name_display}}</span>
                                    <span class="location"
                                          *ngIf="commercials.quote_items[0]?.pod_list.length > 1">{{
                                            commercials.quote_items[0]?.pod_list[1].name_display
                                        }}</span>
                                    <span class="location"
                                          *ngIf="commercials.quote_items[0]?.pod_list.length > 2">{{
                                            commercials.quote_items[0]?.pod_list[2].name_display
                                        }}</span>
                                    <span class="location"
                                          *ngIf="commercials.quote_items[0]?.pod_list.length > 3">{{
                                            commercials.quote_items[0]?.pod_list[3].name_display
                                        }}</span>
                                    <span class="location"
                                          *ngIf="commercials.quote_items[0]?.pod_list.length > 4">{{
                                            commercials.quote_items[0]?.pod_list[4].name_display
                                        }}</span>
                                    <span class="location"
                                          *ngIf="commercials.quote_items[0]?.pod_list.length > 5">{{
                                            commercials.quote_items[0]?.pod_list[5].name_display
                                        }}</span>
                                    <span class="additionalName"
                                          *ngIf="commercials.quote_items[0]?.pod_list?.length > 6"
                                          [matTooltipShowDelay]="400"
                                          [matTooltip]="commercials.quote_items[0]?.pod_list | tooltipList"
                                          matTooltipClass="tooltip-list">
                                        {{
                                            commercials.quote_items[0]?.pod_list?.length > 6 ? "+" +
                                                (commercials.quote_items[0]?.pod_list?.length - 6) +
                                                " more locations" :
                                                commercials.quote_items[0]?.pod_list?.length == 6 ? "+" +
                                                    (commercials.quote_items[0]?.pod_list?.length - 6) +
                                                    " more locations" : ''
                                        }}
                                    </span>
                                </ng-container>
                            </div>
                        </div>
                    </div>

                    <div class="commercialTable shadoo">
                        <div class="colHeader">
                            <div class="Head header" fxFlex="30"><span>Commercials</span></div>
                            <div class="Head dataHead">
                                <span>
                                    Quotation
                                </span>
                            </div>
                        </div>

                        <ng-container *ngIf="requestService.selectedRequest.request_type.dev_name == 'one_way'">
                            <div class="rowSet ">
                                <span fxFlex="30">Pick-up Charge</span>
                                <ng-container *ngIf="commercials.quote_items[0]?.pickup_charge!=null">
                                    <span class="tData">{{commercials.quote_items[0]?.pickup_charge}}
                                        {{commercials.quote_items[0]?.pickup_charge_currency}}</span>
                                </ng-container>
                                <ng-container *ngIf="commercials.quote_items[0]?.pickup_charge == null">
                                    <span class="tData">-</span>
                                </ng-container>
                            </div>

                            <div class="rowSet">
                                <span fxFlex="30">Payee</span>
                                <span class="tData">{{
                                        commercials?.payee == 'arcon' ? 'Arcon pays' :
                                            commercials?.payee == 'customer' ?
                                                'User pays' : commercials?.payee == 'supplier' ? 'Supplier pays' : '-'
                                    }}</span>
                            </div>

                            <div class="rowSet">
                                <span fxFlex="30">Free Days</span>
                                <span class="tData">{{commercials.quote_items[0]?.min_free_days ?? '-'}}</span>
                            </div>

                            <div class="rowSet">
                                <span fxFlex="30">Per Diem charge</span>
                                <ng-container *ngIf="commercials.quote_items[0]?.min_per_diem!=null">
                                    <span class="tData">{{commercials.quote_items[0]?.min_per_diem}}
                                        {{commercials.quote_items[0]?.min_per_diem_currency}}</span>
                                </ng-container>
                                <ng-container *ngIf="commercials.quote_items[0]?.min_per_diem == null">
                                    <span class="tData">-</span>
                                </ng-container>
                            </div>

                            <div class="rowSet">
                                <span fxFlex="30">DPP</span>
                                <ng-container *ngIf="commercials.quote_items[0]?.dpp_charge!=null">
                                    <span class="tData">{{commercials.quote_items[0]?.dpp_charge}}
                                        {{commercials.quote_items[0]?.dpp_charge_currency}}</span>
                                </ng-container>
                                <ng-container *ngIf="commercials.quote_items[0]?.dpp_charge == null">
                                    <span class="tData">-</span>
                                </ng-container>
                            </div>

                            <div class="rowSet">
                                <span fxFlex="30">Storage charge</span>
                                <ng-container *ngIf="commercials.quote_items[0]?.storage_charge!=null">
                                    <span class="tData">{{commercials.quote_items[0]?.storage_charge}}
                                        {{commercials.quote_items[0]?.storage_charge_currency}}</span>
                                </ng-container>
                                <ng-container *ngIf="commercials.quote_items[0]?.storage_charge == null">
                                    <span class="tData">-</span>
                                </ng-container>
                            </div>

                            <!-- Cancellation charge -->
                            <div class="rowSet">
                                <span fxFlex="30">Cancellation charge</span>
                                <ng-container *ngIf="commercials.quote_items[0]?.cancellation_charge!=null">
                                    <span class="tData">{{commercials.quote_items[0]?.cancellation_charge}}
                                        {{commercials.quote_items[0]?.cancellation_charge_currency}}</span>
                                </ng-container>
                                <ng-container *ngIf="commercials.quote_items[0]?.cancellation_charge == null">
                                    <span class="tData">-</span>
                                </ng-container>
                            </div>

                            <div class="rowSet ">
                                <span fxFlex="30">Max usage days</span>
                                <ng-container>
                                    <span>{{commercials.quote_items[0]?.max_free_days ?? '-'}}</span>
                                </ng-container>
                            </div>

                            <div class="rowSet ">
                                <span fxFlex="30">Per Diem post Max usage Days</span>
                                <ng-container *ngIf="commercials.quote_items[0]?.max_per_diem!=null">
                                    <span class="tData">{{commercials.quote_items[0]?.max_per_diem}}
                                        {{commercials.quote_items[0]?.max_per_diem_currency}}</span>
                                </ng-container>
                                <ng-container *ngIf="commercials.quote_items[0]?.max_per_diem == null">
                                    <span class="tData">-</span>
                                </ng-container>
                            </div>

                            <div class="rowSet ">
                                <span fxFlex="30">Drop-off charges</span>
                                <ng-container *ngIf="commercials.quote_items[0]?.dropoff_charge!=null">
                                    <span class="tData">{{commercials.quote_items[0]?.dropoff_charge}}
                                        {{commercials.quote_items[0]?.dropoff_charge_currency}}</span>
                                </ng-container>
                                <ng-container *ngIf="commercials.quote_items[0]?.dropoff_charge == null">
                                    <span class="tData">-</span>
                                </ng-container>
                            </div>
                            <!-- ad hoc charges -->
                            <ng-container *ngIf="commercials.quote_items[0]?.ad_hoc_charges?.length > 0">
                                <ng-container
                                        *ngFor="let charge of commercials.quote_items[0]?.ad_hoc_charges; let i = index">
                                    <div class="rowSet">
                                        <span fxFlex="30">{{charge.quote_charge.charge.print_name}}</span>
                                        <span class="tData">
                                            <ng-container *ngIf="charge.amount!=null">
                                                {{charge.amount}} {{charge.amount_currency}}
                                            </ng-container>
                                            <ng-container *ngIf="charge.amount == null">-</ng-container>
                                        </span>
                                    </div>
                                </ng-container>
                            </ng-container>
                        </ng-container>

                        <ng-container *ngIf="requestService.selectedRequest.request_type.dev_name == 'buy_sell'">
                            <!--                                                        Price -->
                            <div class="rowSet">
                                                           <span
                                                                   *ngIf="requestService.selectedRequest?.transaction_type=='use'"
                                                                   fxFlex="30">Buy-price</span>
                                <span *ngIf="requestService.selectedRequest?.transaction_type=='supply'"
                                      fxFlex="30">Sell-price</span>
                                <ng-container *ngIf="commercials.quote_items[0]?.price !=null">
                                                                <span class="tData">{{
                                                                        commercials.quote_items[0]?.price
                                                                    }}
                                                                    {{
                                                                        commercials.quote_items[0]?.price_currency
                                                                    }}</span>
                                    <span
                                            *ngIf="commercials.quote_items[0]?.csc_validation_included ==true">
                                            (Inclusive of CSC revalidation charges)</span>
                                </ng-container>
                                <ng-container *ngIf="commercials.quote_items[0]?.price == null">
                                    <span class="tData">-</span>
                                </ng-container>
                            </div>

                            <!-- CSC Required -->
                            <div class="rowSet">
                                <span fxFlex="30">CSC revalidation required?*</span>
                                <span class="tData">{{
                                        commercials.quote_items[0]?.csc_revalidation_required ? 'Yes' :
                                            'No'
                                    }}</span>
                            </div>

                            <!-- CSC Revalidation charge -->
                            <div class="rowSet"
                                 *ngIf="commercials.quote_items[0]?.csc_revalidation_required &&
                                 commercials.quote_items[0]?.csc_validation_included==false">
                                <span fxFlex="30">CSC Revalidation charge/cont.*</span>
                                <ng-container *ngIf="commercials.quote_items[0]?.csc_revalidation_charge!=null">
                                    <span class="tData">{{commercials.quote_items[0]?.csc_revalidation_charge}}
                                        {{commercials.quote_items[0]?.csc_revalidation_charge_currency}}</span>
                                </ng-container>
                                <ng-container *ngIf="commercials.quote_items[0]?.csc_revalidation_charge == null">
                                    <span class="tData">-</span>
                                </ng-container>
                            </div>

                            <!-- purchase location -->
                            <div class="rowSet locBox">
                                <span fxFlex="30"
                                      *ngIf="requestService.selectedRequest.transaction_type == 'use'">Purchase
                                    Location</span>
                                <span fxFlex="30"
                                      *ngIf="requestService.selectedRequest.transaction_type == 'supply'">Sell
                                    Location</span>
                                <div *ngIf="commercials.quote_items[0]?.purchase_locations?.length != 0"
                                     class="subLocBox">
                                    <span
                                            class="location">{{
                                            commercials.quote_items[0]?.purchase_locations[0]?.name_display
                                        }}</span>
                                    <span class="location"
                                          *ngIf="commercials.quote_items[0]?.purchase_locations?.length > 1">{{
                                            commercials.quote_items[0]?.purchase_locations[1]?.name_display
                                        }}</span>
                                    <span class="location"
                                          *ngIf="commercials.quote_items[0]?.purchase_locations?.length > 2">{{
                                            commercials.quote_items[0]?.purchase_locations[2]?.name_display
                                        }}</span>
                                    <span class="location"
                                          *ngIf="commercials.quote_items[0]?.purchase_locations?.length > 3">{{
                                            commercials.quote_items[0]?.purchase_locations[3]?.name_display
                                        }}</span>
                                    <span class="location"
                                          *ngIf="commercials.quote_items[0]?.purchase_locations?.length > 4">{{
                                            commercials.quote_items[0]?.purchase_locations[4]?.name_display
                                        }}</span>
                                    <span class="location"
                                          *ngIf="commercials.quote_items[0]?.purchase_locations?.length > 5">{{
                                            commercials.quote_items[0]?.purchase_locations[5]?.name_display
                                        }}</span>
                                    <span class="additionalName"
                                          *ngIf="commercials.quote_items[0]?.purchase_locations.length > 6"
                                          [matTooltipShowDelay]="400"
                                          [matTooltip]="commercials.quote_items[0]?.purchase_locations | tooltipList"
                                          matTooltipClass="tooltip-list">
                                        {{
                                            commercials.quote_items[0]?.purchase_locations?.length > 6 ? "+" +
                                                (commercials.quote_items[0]?.purchase_locations?.length - 6) +
                                                " more locations" :
                                                commercials.quote_items[0]?.purchase_locations.length == 6 ? "+" +
                                                    (commercials.quote_items[0]?.purchase_locations.length - 6) +
                                                    " more locations" :
                                                    ''
                                        }}
                                    </span>
                                </div>
                            </div>

                            <div class="rowSet">
                                <span fxFlex="30">Storage charge</span>
                                <ng-container *ngIf="commercials.quote_items[0]?.storage_charge!=null">
                                    <span class="tData">{{commercials.quote_items[0]?.storage_charge}}
                                        {{commercials.quote_items[0]?.storage_charge_currency}}</span>
                                </ng-container>
                                <ng-container *ngIf="commercials.quote_items[0]?.storage_charge == null">
                                    <span class="tData">-</span>
                                </ng-container>
                            </div>
                            <div class="rowSet">
                                <span fxFlex="30">Free Storage Days</span>
                                <span class="tData">{{commercials.quote_items[0]?.free_storage_days ?? '-'}}</span>
                            </div>

                            <div class="rowSet">
                                <span fxFlex="30">Purpose of Container</span>
                                <span class="tData">{{commercials.quote_items[0]?.purpose | titlecase}}</span>
                            </div>

                            <div class="rowSet" *ngIf="!requestService.confirmBooking">
                                <span fxFlex="30">Quotation valid till*</span>
                                <span class="tData">{{commercials?.quote_valid_till | date:"dd MMM, yyyy"}}</span>
                            </div>

                            <div class="rowSet">
                                <span fxFlex="30">Manufacturing Year</span>
                                <span class="tData">{{commercials.quote_items[0]?.min_manufacturing_year}} -
                                    {{commercials.quote_items[0]?.max_manufacturing_year}} </span>
                            </div>

                            <div class="rowSet">
                                <span fxFlex="30">Color Preference</span>
                                <span class="tData">
                                    <ng-container *ngIf="commercials.quote_items[0]?.color_preference!=null">
                                        <div class="color-box"
                                             [style]="'background:'+commercials.quote_items[0]?.color_preference?.HEX+' ;'">
                                        </div>
                                        {{commercials.quote_items[0]?.color_preference?.RAL}}
                                        {{commercials.quote_items[0]?.color_preference?.name}}
                                    </ng-container>
                                    <ng-container
                                            *ngIf="commercials.quote_items[0]?.color_preference == null">-</ng-container>
                                </span>
                            </div>

                            <div class="rowSet">
                                <span fxFlex="30">Readiness date for Pick-up</span>
                                <span class="tData">
                                    <ng-container *ngIf="commercials.quote_items[0]?.pickup_ready_date!=null">
                                        {{commercials.quote_items[0]?.pickup_ready_date | date:"dd MMM, yyyy"}}
                                    </ng-container>
                                    <ng-container
                                            *ngIf="commercials.quote_items[0]?.pickup_ready_date == null">-</ng-container>
                                </span>
                            </div>
                            <!-- ad hoc charges -->
                            <ng-container *ngIf="commercials.quote_items[0]?.ad_hoc_charges?.length > 0">
                                <ng-container
                                        *ngFor="let charge of commercials.quote_items[0]?.ad_hoc_charges; let i = index">
                                    <div class="rowSet">
                                        <span fxFlex="30">{{charge.quote_charge.charge.print_name}}</span>
                                        <span class="tData">
                                            <ng-container *ngIf="charge.amount!=null">
                                                {{charge.amount}} {{charge.amount_currency}}
                                            </ng-container>
                                            <ng-container *ngIf="charge.amount == null">-</ng-container>
                                        </span>
                                    </div>
                                </ng-container>
                            </ng-container>

                            <div class="rowSet"
                                 *ngIf="requestService.selectedRequest.request_type.dev_name!='buy_sell'">
                                <span fxFlex="30">Req. gets automatical cancelled on</span>
                                <span class="tData">
                                    {{commercials.error.pickup_ready_date | date:"dd MMM, yyyy"}}
                                </span>
                            </div>
                        </ng-container>
                        <!-- SOMETHING NEW -->
                        <ng-container *ngIf="commercials?.ad_hoc_charges?.ad_hoc_charges?.length != 0">
                            <div class="colHeader">
                                <div class="Head dataHead" fxFlex="100"><span>Additional Charges</span></div>
                            </div>
                            <!-- WORK HERE -->
                            <ng-container *ngFor="let commercial of commercials.ad_hoc_charges">
                                <div class="rowSet ">
                                    <span fxFlex="30">{{commercial.quote_charge.charge.print_name}}</span>
                                    <ng-container *ngIf="commercial.amount!=null">
                                        <span class="tData">{{commercial.amount}}
                                            {{commercial.amount_currency}}</span>
                                    </ng-container>
                                    <ng-container *ngIf="commercial.amount == null">
                                        <span class="tData">-</span>
                                    </ng-container>
                                </div>
                            </ng-container>
                        </ng-container>
                    </div>
                    <div class="termsAndCondition shadoo">
                        <span class="title">TERMS AND CONDITIONS</span>
                        <quill-view [content]="commercials.terms_and_condition_text" format="html" theme="snow"
                                    style="max-width: 761px;   overflow: auto;"></quill-view>
                    </div>
                </div>
                <div class="rightReview">
                    <div class="shadoo">
                        <span class="title">EQUIPMENT DETAILS</span>
                        <div class="contentBox" *ngFor="let equipDetails of commercials.quote_items">
                            <logzy-img-loader
                                    [src]="'/assets/images/backgrounds/container_review.png'"></logzy-img-loader>
                            <div class="details">
                                <div>
                                    <span class="label">
                                        Quantity
                                    </span>
                                    <span class="data">:{{equipDetails.quantity}}</span>
                                </div>
                                <div><span class="label">Type</span> <span class="data">:
                                    {{equipDetails.container_size_type?.display}}</span></div>
                                <div><span class="label">Condition</span> <span class="data">:
                                    {{equipDetails.container_condition?.value}}</span></div>

                            </div>
                        </div>
                    </div>
                    <div class="shadoo">
                        <span class="title">CUSTOMER DETAILS</span>
                        <div class="contentBox ">
                            <div class="details ">
                                <div class="d-flex gap-2"><span class="label">Name</span>:<span
                                        class="data">{{requestService.selectedRequest?.requestor?.first_name}}
                                    {{requestService.selectedRequest?.requestor?.last_name}}</span>
                                </div>
                                <div class="d-flex gap-2"><span class="label">Email ID </span>
                                    : <span class="data">{{
                                            requestService.selectedRequest.email != null ?
                                                requestService.selectedRequest.email :
                                                requestService.selectedRequest?.requestor?.email
                                        }}</span>
                                </div>
                                <div class="d-flex gap-2"><span class="label">Company </span>
                                    : <span
                                            class="data">{{requestService.selectedRequest?.requestor?.company?.legal_name ?? requestService.selectedRequest?.requestor?.company?.name}}</span>
                                </div>
                                <div class="d-flex gap-2"><span class="label">Address </span>
                                    : <span
                                            class="data">{{requestService.selectedRequest?.requestor?.company?.address}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="shadoo" *ngIf="requestService.selectedRequest.request_type.dev_name!='buy_sell'">
                        <span class="title">DRV/CONT</span>
                        <div class="drvContent contentBox " *ngFor="let drvDetails of commercials.quote_items">
                            <div class="details">
                                <div class="d-flex gap-2"><span class="label">New Build Price</span>:
                                    <span class="data">
                                        <ng-container *ngIf="drvDetails.drv_new_build_price!=null">
                                            {{drvDetails.drv_new_build_price}}
                                            {{drvDetails.drv_new_build_price_currency}}
                                        </ng-container>
                                        <ng-container *ngIf="drvDetails.drv_new_build_price == null">-</ng-container>
                                    </span>
                                </div>
                                <div class="d-flex gap-2"><span class="label">Depreciation/Year</span>:
                                    <span class="data">
                                        <ng-container *ngIf="drvDetails.drv_depreciation_per_year!=null">
                                            {{drvDetails.drv_depreciation_per_year}}%
                                        </ng-container>
                                        <ng-container
                                                *ngIf="drvDetails.drv_depreciation_per_year == null">-</ng-container>
                                    </span>
                                </div>
                                <div class="d-flex gap-2"><span class="label">Discounted Residual Value</span>:
                                    <span class="data">
                                        <ng-container *ngIf="drvDetails.drv_max_depreciation_unit == 'price'">
                                            <ng-container *ngIf="drvDetails.drv_max_depreciation_price!=null">
                                                {{drvDetails.drv_max_depreciation_price}}
                                                {{drvDetails.drv_max_depreciation_price_currency}}
                                            </ng-container>
                                            <ng-container
                                                    *ngIf="drvDetails.drv_max_depreciation_price == null">-</ng-container>
                                        </ng-container>
                                        <ng-container *ngIf="drvDetails.drv_max_depreciation_unit == 'percent'">
                                            <ng-container *ngIf="drvDetails.drv_max_depreciation_percent!=null">
                                                {{drvDetails.drv_max_depreciation_percent}}%
                                            </ng-container>
                                            <ng-container
                                                    *ngIf="drvDetails.drv_max_depreciation_percent == null">-</ng-container>
                                        </ng-container>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="shadoo" *ngIf="requestService.selectedRequest.request_type.dev_name!='buy_sell'">
                        <span class="title">INSURANCE</span>
                        <div class="contentBox insuranceBox">
                            <logzy-img-loader
                                    [src]="'/assets/images/backgrounds/insurance_icon.jpg'"></logzy-img-loader>
                            <div class="details">
                                <span>{{commercials.insurance?.name}} </span>
                                <!-- <span>{{commercials.insurance?.amount ?? '-'}}
                            {{commercials.insurance?.amount_currency}}/Cont.</span> -->
                                <span>{{commercials.insurance_premium ?? '-'}}
                                    {{commercials.insurance_premium_currency}}/Cont.</span>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="actionBox" *ngIf="reviewing">
                <div fxLayout="row wrap" fxFlex="100">
                    <app-text-field [isEditable]="true" [label]="'Remarks'" [name]="'remarks'" [minlength]="0"
                                    *ngIf="requestService.confirmBooking" [(ngModel)]="remarks" [isMultiline]="true"
                                    [maxlength]="2000" fxFlex="50" fxLayout="column">
                        <!-- [errors]="userObj.error?.remarks" -->
                    </app-text-field>

                    <div fxLayout="row wrap" fxFlex="100">
                        <!-- <mat-checkbox color="primary">Send automatic reminders <i
                                class="flaticon-message primaryIconHover"
                                matTooltip="Let the system remind customer for the quotation"
                                matTooltipPosition="right"></i>
                        </mat-checkbox> -->
                        <div class="btnb">
                            <button class="loadingBtn Save" mat-raised-button (click)="backToQuote()">Back</button>

                            <button class="loadingBtn Save" mat-raised-button [disabled]="disableSaveButton"
                                    (click)="saveQuote()" *ngIf="!requestService.confirmBooking">
                                <span>Send Quote</span>
                            </button>

                            <button class="loadingBtn Save" mat-raised-button [disabled]="disableSaveButton"
                                    (click)="confirmBooking()" *ngIf="requestService.confirmBooking">
                                <span *ngIf="!disableSaveButton">Confirm Booking</span>
                                <div *ngIf="disableSaveButton" class="p03">
                                    <i class="flaticon-loading spin"></i>
                                    <span>Saving...</span>
                                </div>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="vstack">
        <div class="HeaderSet">
            <span class="editHead editHeadCursor"
                  (click)="requestService.bookingDetailsExpand = !requestService.bookingDetailsExpand">
                Booking Summary
                <i class="flaticon-down-chevron" [ngClass]="requestService.bookingDetailsExpand? 'more':'' "></i>
            </span>
        </div>
        <div class="reviewBox" [class.viewExpand]="requestService.bookingDetailsExpand">
            <div fxLayout="row wrap" class="wholeReview">
                <div fxLayout="column" fxFlex="100" class="leftReview">
                    <div class="commercialTable shadoo">
                        <!-- <span class="title">COMMERCIALS</span> -->
                        <div class="reopenBooking">
                            <!-- <span class="title">COMMERCIALS</span> -->
                            <div *ngIf="isRebookingAllowed()" class="rebooking-container">
                                <button mat-raised-button class="addBtn clickIt" (click)="showReopenLogs()">Reopen
                                                                                                            Booking
                                </button>
                                <span class="icon-container"><i class="flaticon-approval-logs" (click)="viewLogs()"></i></span>
                            </div>
                        </div>
                        <div class="colHeader px-12">
                            <div class="Head header" fxFlex="30"><span>Terms </span></div>
                            <div class="Head dataHead">
                                <span fxLayout="row" class="justify-content-between w-100 p-r-10">
                                    Particulars
                                </span>
                            </div>
                        </div>
                        <ng-container *ngIf="requestService.selectedRequest.request_type.dev_name == 'one_way'">
                            <div class="rowSet px-12 pt-2">
                                <span fxFlex="30">Quantity</span>
                                <span class="value">
                                    <ng-container *ngIf="!bookingDetails?.requirements[0]?.editQuantity">
                                        {{bookingDetails?.requirements[0]?.quantity ?? '-'}}
                                        <i class="flaticon-pencil" matTooltipPosition="left"
                                           (click)="bookingDetails.requirements[0].editQuantity = true"
                                           matTooltip="Edit Quantity"></i>
                                    </ng-container>
                                    <div fxLayout="row " class="align-items-center gap-3 justify-content-between w-100"
                                         *ngIf="bookingDetails?.requirements[0]?.editQuantity">
                                        <app-number-field [isEditable]="true" [placeholder]="'Quantity'" fxFlex="15em"
                                                          [(ngModel)]="bookingDetails.requirements[0].quantity" class="pb-2"
                                                          [containerNum]="true" [noDecimal]="true" [maxlength]="4"
                                                          [minValue]="1" [errors]="errorObj.quantity">
                                        </app-number-field>
                                        <!-- <i class="flaticon-save" matTooltipPosition="above"
                                           (click)="postBookingQuantity(bookingDetails.requirements[0])"
                                           matTooltip="Save Quantity"></i> -->
                                    </div>
                                </span>
                            </div>
                            <div class="rowSet px-12">
                                <span fxFlex="30">Condition</span>
                                <span class="value">
                                    <ng-container *ngIf="!bookingDetails?.requirements[0]?.editCondition">
                                        {{bookingDetails?.requirements[0]?.condition ? bookingDetails?.requirements[0]?.condition.value : '-'}}
                                        <!-- <i class="flaticon-pencil"
                                           (click)="bookingDetails.requirements[0].editCondition = true"
                                           matTooltip="Edit Condition"></i> -->
                                    </ng-container>
                                    <!-- <ng-container *ngIf="bookingDetails?.requirements[0]?.editCondition">
                                        <app-mat-auto-search [isEditable]="true" [displayField]="'value'"
                                                             [name]="'container_condition'"
                                                             [(ngModel)]="bookingDetails.requirements[0].condition"
                                                             [idField]="null"
                                                             [listUrl]="containerConditionLists"
                                                             [setSearchValue]="false" class="w-100i pb-2 conditions"
                                                             [errors]="errorObj.condition">
                                        </app-mat-auto-search>
                                    </ng-container> -->
                                </span>
                            </div>
                            <div class="rowSet px-12">
                                <span fxFlex="30">Size Type</span>
                                <span class="value">
                                    <ng-container *ngIf="!bookingDetails?.requirements[0]?.editContainerSizeType">
                                        {{bookingDetails?.requirements[0]?.container_size_type?.display ?? '-'}}
                                        <i class="flaticon-pencil" matTooltipPosition="left"
                                           (click)="bookingDetails.requirements[0].editContainerSizeType = true"
                                           matTooltip="Edit Size Type"
                                        ></i>
                                    </ng-container>
                                    <div fxLayout="row " class="align-items-center gap-3 justify-content-between w-100"
                                         *ngIf="bookingDetails?.requirements[0]?.editContainerSizeType">
                                        <app-mat-auto-search [isEditable]="true"
                                                             class="containerType conditions pb-2" [searchIcon]="true"
                                                             [(ngModel)]="bookingDetails.requirements[0].container_size_type"
                                                             [idField]="null" displayField='display'
                                                             [trim]="true" fxFlex="15em"
                                                             [clearable]="true"
                                                             [listUrl]="containerSizeTypeUrl"
                                                             [errors]="errorObj.container_size_type">
                                        </app-mat-auto-search>
                                        <!-- <i class="flaticon-save" matTooltipPosition="above"
                                           (click)="postContainerSizeType(bookingDetails.requirements[0])"
                                           matTooltip="Save size type"></i> -->
                                    </div>
                                </span>
                            </div>
                            <div class="rowSet px-12">
                                <span fxFlex="30">Pick-up Location</span>
                                <span class="value">
                                <ng-container *ngIf="!bookingDetails?.requirements[0].editPOL">
                                    <div fxLayout="row" class=" gap-1 "
                                         *ngIf="bookingDetails?.requirements[0].pol_list!=null">
                                                <span class="location">{{
                                                        bookingDetails?.requirements[0].pol_list[0]?.name_display ??
                                                        '-'
                                                    }}</span>
                                        <span class="location"
                                              *ngIf="bookingDetails?.requirements[0].pol_list?.length > 1"> |
                                            {{bookingDetails?.requirements[0].pol_list[1]?.name_display}}</span>
                                        <span class="additionalLoc"
                                              *ngIf="bookingDetails?.requirements[0].pol_list?.length > 2"
                                              [matTooltipShowDelay]="400"
                                              [matTooltip]="bookingDetails?.requirements[0].pol_list | tooltipList"
                                              matTooltipClass="tooltip-list">{{
                                                bookingDetails?.requirements[0].pol_list?.length > 2
                                                    ? "  +" + (bookingDetails?.requirements[0].pol_list?.length - 2) + " more locations"
                                                    : bookingDetails?.requirements[0].pol_list?.length == 2
                                                        ? "  +" + (bookingDetails?.requirements[0].pol_list?.length - 2) + " more locations"
                                                        : ''
                                            }}
                                                </span>
                                    </div>
                                    <i class="flaticon-pencil" (click)="bookingDetails.requirements[0].editPOL = true; bookingDetails.requirements[0].editPOD =
                                            true" matTooltipPosition="left" matTooltip="Edit Locations"></i>
                                </ng-container>
                                <div fxLayout="row " class="align-items-center gap-3 justify-content-between w-100"
                                     *ngIf="bookingDetails?.requirements[0].editPOL">
                                    <app-mat-auto-search [(ngModel)]="bookingDetails.requirements[0].pol_list"
                                                         [isEditable]="true"
                                                         [idField]="null" displayField='name_display'
                                                         [trim]="true"
                                                         [multiple]="true"
                                                         [defaultChip]="false" [clearable]="true"
                                                         [closeOnSelect]="false"
                                                         [clearSearchOnAdd]="true"
                                                         [listUrl]="location_url" name="pods" fxLayout="column"
                                                         class=" locations pb-2" fxFlex="15em"
                                                         [errors]="errorObj.pol_list">
                                        </app-mat-auto-search>
                                    <!-- <i class="flaticon-save" matTooltipPosition="above"
                                       (click)="postBookingLocation(bookingDetails.requirements[0])"
                                       matTooltip="Save Booking Location"></i> -->
                                </div>
                                </span>
                            </div>
                            <div class="rowSet px-12">
                                <span fxFlex="30">Drop-off Location</span>
                                <span class="value">
                                <ng-container *ngIf="!bookingDetails?.requirements[0]?.editPOD">
                                    <div fxLayout="row" class=" gap-1 "
                                         *ngIf="bookingDetails?.requirements[0]?.pod_list!=null">
                                                <span class="location">{{
                                                        bookingDetails?.requirements[0]?.pod_list[0]?.name_display ??
                                                        '-'
                                                    }}</span>
                                        <span class="location"
                                              *ngIf="bookingDetails?.requirements[0]?.pod_list.length > 1"> | {{
                                                bookingDetails?.requirements[0]?.pod_list[1]?.name_display
                                            }}</span>
                                        <span class="additionalLoc"
                                              *ngIf="bookingDetails?.requirements[0]?.pod_list?.length > 2"
                                              [matTooltipShowDelay]="400"
                                              [matTooltip]="bookingDetails?.requirements[0]?.pod_list | tooltipList"
                                              matTooltipClass="tooltip-list">{{
                                                bookingDetails?.requirements[0]?.pod_list?.length > 2
                                                    ? "  +" + (bookingDetails?.requirements[0]?.pod_list?.length - 2) + " more locations" :
                                                    bookingDetails?.requirements[0]?.pod_list?.length == 2
                                                        ? "  +" + (bookingDetails?.requirements[0]?.pod_list?.length - 2) + " more locations"
                                                        : ''
                                            }}
                                                </span>
                                    </div>
                                    <!--                                            <i class="flaticon-pencil" (click)="bookingDetails.requirements[0].editPOD = true"></i>-->
                                </ng-container>
                                <ng-container *ngIf="bookingDetails?.requirements[0]?.editPOD">
                                    <app-mat-auto-search [(ngModel)]="bookingDetails.requirements[0].pod_list"
                                                         [isEditable]="true"
                                                         [idField]="null" displayField='name_display'
                                                         [trim]="true"
                                                         [multiple]="true"
                                                         [defaultChip]="false" [clearable]="true"
                                                         [closeOnSelect]="false"
                                                         [clearSearchOnAdd]="true" fxFlex="15em"
                                                         [listUrl]="location_url" name="pods" fxLayout="column"
                                                         class=" pb-2 locations"
                                                         [errors]="errorObj.pod_list">
                                    </app-mat-auto-search>
                                </ng-container>
                                </span>
                            </div>
                            <div class="rowSet px-12">
                                <!-- <span fxFlex="30">Per Diem charge</span>
                                                            <ng-container *ngIf="bookingDetails?.requirements[0]?.min_per_diem!=null">
                                                                <span class="tData value">{{ bookingDetails?.requirements[0]?.min_per_diem }}
                                                                    {{ bookingDetails?.requirements[0]?.min_per_diem_currency }}</span>
                                                            </ng-container>
                                                            <ng-container *ngIf="bookingDetails?.requirements[0]?.min_per_diem == null">
                                                                <span class="tData value">-</span>
                                                            </ng-container> -->
                                <span fxFlex="30">Per Diem charge</span>
                                <span class="value">
                                    <ng-container *ngIf="!bookingDetails?.requirements[0]?.editPerDiemCharge">
                                        {{bookingDetails?.requirements[0]?.min_per_diem}}
                                            {{bookingDetails?.requirements[0]?.min_per_diem_currency}}
                                        <i class="flaticon-pencil" matTooltipPosition="left"
                                           (click)="bookingDetails.requirements[0].editPerDiemCharge = true"
                                           matTooltip="Edit Per Diem Charge"></i>
                                    </ng-container>
                                    <ng-container *ngIf="bookingDetails?.requirements[0]?.editPerDiemCharge">
                                        <logzy-money-field [isEditable]="true" [placeholder]="'Per Diem Charge'"
                                                           fxFlex="15em"
                                                           [(amount)]="bookingDetails.requirements[0].min_per_diem"
                                                           [minValue]="0" class="charges"
                                                           [(currencyCode)]="bookingDetails?.requirements[0].min_per_diem_currency"
                                                           [errors]="errorObj.quantity">
                                        </logzy-money-field>
                                        <!-- <i class="flaticon-save" (click)="postOnewayfreedaysPerdiem(bookingDetails.requirements[0])"
                                            matTooltip="Save Data"></i> -->
                                    </ng-container>
                                </span>
                            </div>
                            <div class="rowSet px-12">
                                <span fxFlex="30">Per Diem post Max usage Days</span>
                                <!-- <ng-container *ngIf="bookingDetails?.requirements[0]?.max_per_diem!=null">
                                    <span class="tData value">{{ bookingDetails?.requirements[0]?.max_per_diem }}
                                        {{ bookingDetails?.requirements[0]?.max_per_diem_currency }}</span>
                                </ng-container>
                                <ng-container *ngIf="bookingDetails?.requirements[0]?.max_per_diem == null">
                                    <span class="tData value">-</span>
                                </ng-container> -->
                                <span class="value ">
                                <ng-container *ngIf="!bookingDetails?.requirements[0]?.editMaxPerDiemCharge">
                                    {{bookingDetails?.requirements[0]?.max_per_diem}}
                                        {{bookingDetails?.requirements[0]?.max_per_diem_currency}}
                                    <i class="flaticon-pencil" matTooltipPosition="left"
                                       (click)="bookingDetails.requirements[0].editMaxPerDiemCharge = true"
                                       matTooltip="Edit Max Per Diem Charge"></i>
                                </ng-container>
                                <ng-container *ngIf="bookingDetails?.requirements[0]?.editMaxPerDiemCharge">
                                    <logzy-money-field [isEditable]="true" [placeholder]="'Per Diem Charge'"
                                                       fxFlex="15em" class="charges"
                                                       [(amount)]="bookingDetails.requirements[0].max_per_diem"
                                                       [minValue]="0"
                                                       [(currencyCode)]="bookingDetails?.requirements[0].max_per_diem_currency"
                                                       [errors]="errorObj.max_per_diem">
                                    </logzy-money-field>
                                    <!-- <i class="flaticon-save" (click)="postOnewayfreedaysPerdiem(bookingDetails.requirements[0])"
                                        matTooltip="Save Data"></i> -->
                                </ng-container>
                                </span>
                            </div>

                            <div class="rowSet px-12">
                                <span fxFlex="30">Max Free Days</span>
                                <span class="value">
                                    <ng-container *ngIf="!bookingDetails?.requirements[0]?.editMaxFreeDays">
                                        {{bookingDetails?.requirements[0]?.max_per_diem_free_days}}
                                        <i class="flaticon-pencil" matTooltipPosition="left"
                                           (click)="bookingDetails.requirements[0].editMaxFreeDays = true"
                                           matTooltip="Edit Free Days"></i>
                                    </ng-container>
                                    <ng-container *ngIf="bookingDetails?.requirements[0]?.editMaxFreeDays">
                                        <app-number-field [isEditable]="true" [placeholder]="'Max Free Days'"
                                                          fxFlex="15em"
                                                          [(ngModel)]="bookingDetails.requirements[0].max_per_diem_free_days"
                                                          [noDecimal]="true" [maxlength]="4"
                                                          [minValue]="1" [errors]="errorObj.max_per_diem_free_days">
                                    </app-number-field>
                                        <!-- <i class="flaticon-save" (click)="postOnewayfreedaysPerdiem(bookingDetails.requirements[0])"
                                            matTooltip="Save Data"></i> -->
                                    </ng-container>
                                </span>
                            </div>

                            <div class="rowSet px-12">
                                <span fxFlex="30">Min Free Days</span>
                                <span class="value">
                                    <ng-container *ngIf="!bookingDetails?.requirements[0]?.editMinFreeDays">
                                        {{bookingDetails?.requirements[0]?.min_per_diem_free_days}}
                                        <i class="flaticon-pencil" matTooltipPosition="left"
                                           (click)="bookingDetails.requirements[0].editMinFreeDays = true"
                                           matTooltip="Edit Free Days"></i>
                                    </ng-container>
                                    <ng-container *ngIf="bookingDetails?.requirements[0]?.editMinFreeDays">
                                        <app-number-field [isEditable]="true" [placeholder]="'Min Free Days'"
                                                          fxFlex="15em"
                                                          [(ngModel)]="bookingDetails.requirements[0].min_per_diem_free_days"
                                                          [noDecimal]="true" [maxlength]="4"
                                                          [minValue]="0" [errors]="errorObj.min_per_diem_free_days">
                                    </app-number-field>
                                        <!-- <i class="flaticon-save" (click)="postOnewayfreedaysPerdiem(bookingDetails.requirements[0])"
                                            matTooltip="Save Data"></i> -->
                                    </ng-container>
                                </span>
                            </div>

                            <div class="rowSet px-12">
                                <span fxFlex="30">Storage charge</span>
                                <ng-container *ngIf="bookingDetails?.requirements[0]?.storage_charge!=null">
                                        <span class="tData value">{{bookingDetails?.requirements[0]?.storage_charge}}
                                            {{bookingDetails?.requirements[0]?.storage_charge_currency}}</span>
                                </ng-container>
                                <ng-container *ngIf="bookingDetails?.requirements[0]?.storage_charge == null">
                                    <span class="tData value">-</span>
                                </ng-container>
                            </div>
                            <div class="btnb" *ngIf="bookingDetails?.requirements[0].editQuantity || bookingDetails?.requirements[0].editPOL ||
                             bookingDetails?.requirements[0].editPOD || bookingDetails?.requirements[0].editCondition
                              || bookingDetails?.requirements[0].editContainerSizeType || bookingDetails?.requirements[0].editPerDiemCharge || bookingDetails?.requirements[0].editMaxFreeDays || bookingDetails?.requirements[0].editMinFreeDays|| bookingDetails?.requirements[0].editMaxPerDiemCharge"
                                 style="display: flex;
                                        justify-content: end;
                                        margin-top: 10px;
                                        gap: 10px;">
                                <button mat-raised-button (click)="saveRequirement()" class="addBtn clickIt">
                                    Save
                                </button>
                                <button mat-raised-button (click)="reset()" class="Save">
                                    Cancel
                                </button>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="requestService.selectedRequest.request_type.dev_name == 'buy_sell'">
                            <div class="rowSet px-12 pt-2">
                                <span fxFlex="30">Quantity</span>
                                <span class="value">
                                    <ng-container *ngIf="!bookingDetails?.requirements[0]?.editQuantity">
                                        {{bookingDetails?.requirements[0]?.quantity ?? '-'}}
                                        <i class="flaticon-pencil" matTooltipPosition="left"
                                           (click)="bookingDetails.requirements[0].editQuantity = true"
                                           matTooltip="Edit Quantity"></i>
                                    </ng-container>
                                    <div fxLayout="row " class="align-items-center gap-3 justify-content-between w-100"
                                         *ngIf="bookingDetails?.requirements[0]?.editQuantity">
                                        <app-number-field [isEditable]="true" [placeholder]="'Quantity'"
                                                          class="pb-2" fxFlex="15em"
                                                          [(ngModel)]="bookingDetails.requirements[0].quantity"
                                                          [containerNum]="true"
                                                          [noDecimal]="true"
                                                          [maxlength]="4"
                                                          [minValue]="1"
                                                          [errors]="errorObj.quantity">
                                        </app-number-field>
                                        <!-- <i class="flaticon-save" matTooltipPosition="above"
                                           (click)="postBookingQuantity(bookingDetails.requirements[0])"
                                           matTooltip="Save Quantity"></i> -->
                                    </div>
                                </span>
                            </div>
                            <div class="rowSet px-12">
                                <span fxFlex="30">Condition</span>
                                <span class="value">
                                    <ng-container *ngIf="!bookingDetails?.requirements[0]?.editCondition">
                                        {{bookingDetails?.requirements[0]?.condition ? bookingDetails?.requirements[0]?.condition.value : '-'}}
                                        <!-- <i class="flaticon-pencil"
                                           (click)="bookingDetails.requirements[0].editCondition = true"
                                           matTooltip="Edit Condition"></i> -->
                                    </ng-container>
                                    <!-- <ng-container *ngIf="bookingDetails?.requirements[0]?.editCondition">
                                        <app-mat-auto-search [isEditable]="true" [displayField]="'value'"
                                                             [name]="'container_condition'"
                                                             [(ngModel)]="bookingDetails.requirements[0].condition"
                                                             [idField]="null"
                                                             [listUrl]="containerConditionLists"
                                                             [setSearchValue]="false" class="w-100i conditions"
                                                             [errors]="errorObj.condition">
                                        </app-mat-auto-search>
                                    </ng-container> -->
                                </span>
                            </div>
                            <div class="rowSet px-12">
                                <span fxFlex="30">Size Type</span>
                                <span class="value">
                                    <ng-container *ngIf="!bookingDetails?.requirements[0]?.editContainerSizeType">
                                        {{bookingDetails?.requirements[0]?.container_size_type?.display ?? '-'}}
                                        <i class="flaticon-pencil" matTooltipPosition="left"
                                           (click)="bookingDetails.requirements[0].editContainerSizeType = true"
                                           matTooltip="Edit Size Type"
                                        ></i>
                                    </ng-container>
                                    <div fxLayout="row " class="align-items-center gap-3 justify-content-between w-100"
                                         *ngIf="bookingDetails?.requirements[0]?.editContainerSizeType">
                                        <app-mat-auto-search [isEditable]="true" fxFlex="15em"
                                                             class="containerType pb-2 conditions" [searchIcon]="true"
                                                             [(ngModel)]="bookingDetails.requirements[0].container_size_type"
                                                             [idField]="null" displayField='display'
                                                             [trim]="true"
                                                             [clearable]="true"
                                                             [listUrl]="containerSizeTypeUrl"
                                                             [errors]="errorObj.container_size_type">
                                        </app-mat-auto-search>
                                        <!-- <i class="flaticon-save" matTooltipPosition="above"
                                           (click)="postContainerSizeType(bookingDetails.requirements[0])"
                                           matTooltip="Save size type"></i> -->
                                    </div>
                                </span>
                            </div>
                            <!-- purchase location -->
                            <div class="rowSet px-12">
                                <span fxFlex="30"
                                      *ngIf="requestService.selectedRequest.transaction_type == 'use'">Purchase
                                    Location</span>
                                <span fxFlex="30"
                                      *ngIf="requestService.selectedRequest.transaction_type == 'supply'">Sell
                                    Location</span>
                                <span class="value">
                                <ng-container *ngIf="!bookingDetails?.requirements[0].editPOL">
                                    <div fxLayout="row" class=" gap-1 "
                                         *ngIf="bookingDetails?.requirements[0].pol_list!=null">
                                                <span class="location">{{
                                                        bookingDetails?.requirements[0].pol_list[0]?.name_display ??
                                                        '-'
                                                    }}</span>
                                        <span class="location"
                                              *ngIf="bookingDetails?.requirements[0].pol_list?.length > 1"> |
                                            {{bookingDetails?.requirements[0].pol_list[1]?.name_display}}</span>
                                        <span class="additionalLoc"
                                              *ngIf="bookingDetails?.requirements[0].pol_list?.length > 2"
                                              [matTooltipShowDelay]="400"
                                              [matTooltip]="bookingDetails?.requirements[0].pol_list | tooltipList"
                                              matTooltipClass="tooltip-list">{{
                                                bookingDetails?.requirements[0].pol_list?.length > 2
                                                    ? "  +" + (bookingDetails?.requirements[0].pol_list?.length - 2) + " more locations"
                                                    : bookingDetails?.requirements[0].pol_list?.length == 2
                                                        ? "  +" + (bookingDetails?.requirements[0].pol_list?.length - 2) + " more locations"
                                                        : ''
                                            }}
                                                </span>
                                    </div>
                                    <i class="flaticon-pencil" (click)="bookingDetails.requirements[0].editPOL = true;" matTooltipPosition="left"
                                       matTooltip="Edit Locations"></i>
                                </ng-container>
                                <div fxLayout="row " class="align-items-center gap-3 justify-content-between w-100"
                                     *ngIf="bookingDetails?.requirements[0].editPOL">
                                    <app-mat-auto-search [(ngModel)]="bookingDetails.requirements[0].pol_list"
                                                         [isEditable]="true"
                                                         [idField]="null" displayField='name_display'
                                                         [trim]="true"
                                                         [multiple]="true"
                                                         [defaultChip]="false" [clearable]="true"
                                                         [closeOnSelect]="false"
                                                         [clearSearchOnAdd]="true"
                                                         [listUrl]="location_url" name="pods" fxLayout="column"
                                                         class=" pb-2 locations" fxFlex="15em"
                                                         [errors]="errorObj.pol_list">
                                    </app-mat-auto-search>
                                    <!-- <i class="flaticon-save" matTooltipPosition="above"
                                       (click)="postBookingLocation(bookingDetails.requirements[0])"
                                       matTooltip="Save Booking Location"></i> -->
                                </div>
                                </span>
                            </div>

                            <!-- CSC Required -->
                            <div class="rowSet px-12">
                                <span fxFlex="30">CSC revalidation required?*</span>
                                <span class="tData value">{{
                                        bookingDetails?.requirements[0]?.csc_revalidation_required ? 'Yes' :
                                            'No'
                                    }}</span>
                            </div>

                            <!-- CSC Revalidation charge -->
                            <div class="rowSet px-12"
                                 *ngIf="bookingDetails?.requirements[0]?.csc_revalidation_required &&
                                 bookingDetails?.requirements[0]?.csc_validation_included==false">
                                <span fxFlex="30">CSC Revalidation charge/cont.*</span>
                                <ng-container *ngIf="bookingDetails?.requirements[0]?.csc_revalidation_charge!=null">
                                    <span class="tData value">{{bookingDetails?.requirements[0]?.csc_revalidation_charge}}
                                        {{bookingDetails?.requirements[0]?.csc_revalidation_charge_currency}}</span>
                                </ng-container>
                                <ng-container *ngIf="bookingDetails?.requirements[0]?.csc_revalidation_charge == null">
                                    <span class="tData value">-</span>
                                </ng-container>
                            </div>

                            <div class="rowSet px-12">
                                <span fxFlex="30">Storage charge</span>
                                <ng-container *ngIf="bookingDetails?.requirements[0]?.storage_charge!=null">
                                    <span class="tData value">{{bookingDetails?.requirements[0]?.storage_charge}}
                                        {{bookingDetails?.requirements[0]?.storage_charge_currency}}</span>
                                </ng-container>
                                <ng-container *ngIf="bookingDetails?.requirements[0]?.storage_charge == null">
                                    <span class="tData value">-</span>
                                </ng-container>
                            </div>
                            <div class="rowSet px-12">
                                <span fxFlex="30">Free Storage Days</span>
                                <span
                                        class="tData value">{{bookingDetails?.requirements[0]?.free_storage_days ?? '-'}}</span>
                            </div>

                            <div class="rowSet px-12">
                                <span fxFlex="30">Purpose of Container</span>
                                <span class="tData value">{{bookingDetails?.requirements[0]?.purpose | titlecase}}</span>
                            </div>

                            <div class="rowSet px-12" *ngIf="!requestService.confirmBooking">
                                <span fxFlex="30">Quotation valid till*</span>
                                <span class="tData value">{{commercials?.quote_valid_till | date:"dd MMM, yyyy"}}</span>
                            </div>
                            <div class="btnb" *ngIf="bookingDetails?.requirements[0].editQuantity || bookingDetails?.requirements[0].editPOL
                                || bookingDetails?.requirements[0].editPOD || bookingDetails?.requirements[0].editContainerSizeType"
                                 style="display: flex;
                                        justify-content: end;
                                        margin-top: 10px;
                                        gap: 10px;">
                                <button mat-raised-button (click)="saveRequirement()" class="addBtn clickIt">
                                    Save
                                </button>
                                <button mat-raised-button (click)="reset()" class="Save">
                                    Cancel
                                </button>
                            </div>
                        </ng-container>
                    </div>
                    <div fxLayout="column" class="w-100 shadoo ">
                        <span class="title">BOOKING CHARGES</span>
                        <logzy-booking-charges (reqContainers)="showContainers($event)"
                                               (addInvoiceParty)="invoiceParty($event)"></logzy-booking-charges>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Color preference Dropdown -->
<ng-template #ralItemTemplate let-item>
    <div class="ral-container">
        <div class="color-box" [style.background-color]="item?.HEX"></div>
        <div class="color">
            <span class="ral-code">{{item?.RAL ?? '-'}}</span>
            <span class="color-name">{{item?.name ?? '-'}}</span>
        </div>
    </div>
</ng-template>

<ng-template #ralLabelItemTemplate let-item>
    {{item?.name ?? '-'}}
</ng-template>
